import { useRef, useState, useEffect } from "react";
import moment from "moment";

function formatMilliseconds(milliseconds) {
	return moment(milliseconds).format("mm:ss");
}

function useBoostCountdown({ endTime = 0, startTime = 0 } = {}) {
	const [countdownTime, setCountdownTime] = useState();
	const [countdownProgress, setCountdownProgress] = useState();

	const startCountdownTimer = useRef();

	useEffect(() => {
		let timeLeftInMs = (endTime) - new Date().getTime();

		if (!endTime || timeLeftInMs <= 1000) {
			return clearInterval(startCountdownTimer.current);
		}

		const updateCountdown = () => {
			timeLeftInMs -= 1000;
			const formattedTimeLeft = formatMilliseconds(timeLeftInMs);
			const boostTotalTimeInMS = (endTime - startTime);

			const progressBarTimeLeft = ((boostTotalTimeInMS - timeLeftInMs) / boostTotalTimeInMS) * 100;
			const progressBarCountdownTimeLeft = (100 - progressBarTimeLeft.toFixed(2));

			setCountdownTime(formattedTimeLeft);
			setCountdownProgress(`${progressBarCountdownTimeLeft}%`);

			if (!endTime || timeLeftInMs <= 1000) {
				clearInterval(startCountdownTimer.current);
			}
		};

		// Run once, then again every second.
		updateCountdown();
		startCountdownTimer.current = setInterval(updateCountdown, 1000);

		return () => clearInterval(startCountdownTimer.current);
	}, [endTime, startTime]);

	return {
		countdownTime,
		countdownProgress,
	};
}

export default useBoostCountdown;



// WEBPACK FOOTER //
// ./src/shared/hooks/useBoostCountdown.js